
import { createReducer } from '@reduxjs/toolkit';
import RightActions from './actions';

export interface IRightState {
    selectedUserDivisionIds : Array<number>;
    selectedUserPrintServerIds : Array<number>;
    selectedResponsibleEmployeeId : number | null; 
}

const initialState = {
    masterDataSyncIsLoading: false,

    selectedUserDivisionIds: [],
    selectedUserPrintServerIds: [],
    selectedResponsibleEmployeeId: null
};

const rightReducer = createReducer<IRightState>(initialState, (builder) => {
    builder.addCase(RightActions.setSelectedUserDivisionIds, (state, action) => {
        state.selectedUserDivisionIds = action.payload;
    });
    builder.addCase(RightActions.setSelectedUserPrintServerIds, (state, action) => {
        state.selectedUserPrintServerIds = action.payload;
    });
    builder.addCase(RightActions.setSelectedResponsibleEmployeeId, (state, action) => {
        state.selectedResponsibleEmployeeId = action.payload;
    });
    builder.addCase(RightActions.reset, () => {
        return initialState;
    });
});

export default rightReducer;
